
const optionsToQuery = (options) => {
  console.log(options)
  if(Object.keys(options).length == 0) 
    return "" 

  let query = "";
  Object.keys(options).forEach(option =>{
    if(options[option])
      query += `${option}=${options[option]}&`
  })

  return query;
};

export default optionsToQuery;